import React, { PureComponent } from 'react';
import { injectIntl, defineMessages } from 'react-intl';

import { Icon } from 'semantic-ui-react';
import Tooltip from 'material-ui/Tooltip';
import { AdminTargetEditModal } from 'components';

import { CtAdminTargetDelete } from 'containers';

import classNames from 'classnames/bind';
import styles from './AdminTargetInTableMenu.css';
const cx = classNames.bind(styles);

class AdminTargetInTableMenu extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      deleteModal: false,
      editModal: false
    };
  }

  mountDeleteModal = () => {
    this.setState({ deleteModal: !this.state.deleteModal });
  };

  mountEditModal = () => {
    this.setState({ editModal: !this.state.editModal });
  };

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { deleteModal, editModal } = this.state;
    const { isAuth, targetInfo } = this.props;
    const { mountDeleteModal, mountEditModal } = this;

    return (
      <div className={'inline-conf-area'}>
        <Tooltip
          title={defineMessages(formatMessage({ id: 'AdminTargetInTableMenu_1', defaultMessage: '대상자 수정' }))}
          placement="bottom">
          <Icon color="grey" className={cx('icon-edit')} name="edit" link onClick={mountEditModal} />
        </Tooltip>
        {editModal && <AdminTargetEditModal isAuth={isAuth} targetInfo={targetInfo} mountEditModal={mountEditModal} />}

        {/* <Tooltip
          title={defineMessages(formatMessage({ id: 'AdminTargetInTableMenu_2', defaultMessage: '대상자 삭제' }))}
          placement="bottom">
          <Icon color="grey" className="icon-remove" name="remove circle" link onClick={mountDeleteModal} />
        </Tooltip> */}
        {/* {deleteModal && <CtAdminTargetDelete targetInfo={targetInfo} mountDeleteModal={mountDeleteModal} />} */}
      </div>
    );
  }
}

export default injectIntl(AdminTargetInTableMenu);



// WEBPACK FOOTER //
// ./src/script/components/admin/target/AdminTargetInTableMenu.js